module.exports = __webpack_public_path__ + "static/media/50_A.6bde89f2.png";